"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.darkVariables = exports.lightVariables = void 0;
var lightVariables = {
  background: "#f2f6f9",
  textColor: "#1c273a",
  titleColor: "#1c273a",
  structure: "#DEE8F0",
  icon: "#566074"
};
exports.lightVariables = lightVariables;
var darkVariables = {
  background: "#262A34",
  textColor: "#C9C8E1",
  titleColor: "white",
  structure: "#4F4D67",
  icon: "#8786A9"
};
exports.darkVariables = darkVariables;